import classNames from 'classnames';
import React from 'react';

interface IProps {
  children: React.ReactNode;
  compressed?: boolean;
  className?: string;
}

export const Card: React.FC<IProps> = (props) => {
  return (
    <div
      className={classNames(
        'divide-y divide-gray-100 overflow-hidden bg-white shadow-sm ring-1 ring-gray-900/5 rounded-xl mb-8 p-4 sm:p-6',
        props.compressed ? 'py-2 sm:py-4' : 'p-4 sm:py-6',
        props.className,
      )}>
      {props.children}
    </div>
  );
};
